// 正式

module.exports = {
  title: 'prod',
  // 生产环境
  baseApi: '//boo-st.id',
};
